import { SearchIcon } from '@heroicons/react/outline';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { useMemo, useState } from 'react';
import { useMevosUsers } from '../../hooks/useMevosUsers';
import { useUser } from '../../hooks/useUser';

const UserList = () => {
  const usersQuery = useMevosUsers();
  const userQuery = useUser();
  const [filter, setFilter] = useState('');

  const columns: GridColDef[] = useMemo(() => {
    return [
      {
        field: 'Voornaam',
        headerName: 'Voornaam',
        flex: 1,
        headerClassName: 'bg-gray-100',
      },
      {
        field: 'Achternaam',
        headerName: 'Achternaam',
        flex: 1,
        headerClassName: 'bg-gray-100',
      },
      {
        field: 'Email',
        headerName: 'email',
        flex: 1,
        headerClassName: 'bg-gray-100',
      },
      {
        field: 'PersonType',
        headerName: 'Medewerker/mentor',
        flex: 1,
        headerClassName: 'bg-gray-100',
      },
    ];
  }, []);

  const filteredList = useMemo(() => {
    if (!usersQuery.data) return [];
    if (!userQuery.isSuccess) return [];

    return usersQuery.data.filter((user) => {
      const currentUser = userQuery.data;
      const isSuperAdmin = currentUser.role === 'SUPER_ADMIN';
      const currentUserBranch = currentUser.branch.toLowerCase();
      const userEmail = user.Email || '';
      const userBranch = user.Branch.toLowerCase();

      // If not included in filter, dont show
      if (!userEmail.toLowerCase().includes(filter)) return false;
      // If not in the admin branchs, dont show. Unless user is super admin
      if (currentUserBranch !== userBranch && !isSuperAdmin) return false;

      return true;
    });
  }, [usersQuery.data, filter, userQuery]);

  if (usersQuery.isLoading) return null;
  if (usersQuery.isError) throw usersQuery.error;

  return (
    <section className="flex flex-col space-y-3">
      <div className="relative w-1/2">
        <input
          type="text"
          id="first_name"
          className="bg-grey-light-50 border border-gray-300 text-gray-900 text-sm rounded-sm focus:ring-sky focus:border-sky block w-full p-2.5"
          placeholder={'Email'}
          onChange={(e) => setFilter(e.target.value.toLowerCase())}
        />
        <SearchIcon className="w-5 absolute right-3 top-2.5" />
      </div>
      <DataGrid
        autoHeight
        rows={filteredList}
        columns={columns}
        getRowId={(row) => row._id}
        className="bg-white"
      />
    </section>
  );
};

export default UserList;
